const IS_MAC = typeof navigator !== `undefined` && /Mac|iPhone|iPad/.test(navigator.platform)

/** The platform's primary shortcut modifier, as its keycap reads. */
export const MODIFIER_KEY = IS_MAC ? `⌘` : `Ctrl`
